import { render, staticRenderFns } from "./app-video-box.vue?vue&type=template&id=c56edeb2&scoped=true&"
import script from "./app-video-box.vue?vue&type=script&lang=js&"
export * from "./app-video-box.vue?vue&type=script&lang=js&"
import style0 from "./app-video-box.vue?vue&type=style&index=0&id=c56edeb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56edeb2",
  null
  
)

export default component.exports